import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

export const THOUSAND_LIMIT = 1000;

export const examTypeLabels: Record<number, string> = {
  [racehorse360.HorseExamRequirementTypeCode
    .HORSE_EXAM_REQUIREMENT_TYPE_CODE_ENTRY_EXAM]:
    "Days Since Last Race – Entry Exam",
  [racehorse360.HorseExamRequirementTypeCode
    .HORSE_EXAM_REQUIREMENT_TYPE_CODE_HISA]:
    "Days Since Last Race – Entry Exam – HISA Form",
  [racehorse360.HorseExamRequirementTypeCode
    .HORSE_EXAM_REQUIREMENT_TYPE_CODE_TSE1]:
    "Days Since Last Race/Work – TSE-1 Exam",
  [racehorse360.HorseExamRequirementTypeCode
    .HORSE_EXAM_REQUIREMENT_TYPE_CODE_TSE2]:
    "Days Since TSE-1 Exam – TSE-2 Exam Needed",
  [racehorse360.HorseExamRequirementTypeCode
    .HORSE_EXAM_REQUIREMENT_TYPE_CODE_INVALID]: "Unknown"
};

export const mobileExamTypeLabels: Record<number, string> = {
  [racehorse360.HorseExamRequirementTypeCode
    .HORSE_EXAM_REQUIREMENT_TYPE_CODE_ENTRY_EXAM]: "Days Off - Entry Exam",
  [racehorse360.HorseExamRequirementTypeCode
    .HORSE_EXAM_REQUIREMENT_TYPE_CODE_HISA]:
    "Days Off - Entry Exam - HISA Form",
  [racehorse360.HorseExamRequirementTypeCode
    .HORSE_EXAM_REQUIREMENT_TYPE_CODE_TSE1]: "Days Off Work - TSE-1 Exam",
  [racehorse360.HorseExamRequirementTypeCode
    .HORSE_EXAM_REQUIREMENT_TYPE_CODE_TSE2]: "Days Off Work - TSE-2 Exam",
  [racehorse360.HorseExamRequirementTypeCode
    .HORSE_EXAM_REQUIREMENT_TYPE_CODE_INVALID]: "Unknown"
};
